import { parseReportDateForSort } from "./reportDateSortUtils";
import { getNextSortConfig } from "./dailySaleReportTableConfig";

export { getNextSortConfig };

export const QUOTATION_REPORT_COLUMN_FIELDS = [
  null,
  "date",
  "Refno",
  "SKU",
  "metal_name",
  "stone_name",
  "size_name",
  "qty",
  "base_amount",
  "service_labour",
  "amount",
  "location_name",
  "customer_name",
  "sales_person",
  null,
];

const NUMERIC_FIELDS = new Set([
  "qty",
  "base_amount",
  "service_labour",
  "amount",
]);

const getSortValue = (row, field) => {
  const value = row?.[field];
  if (value === null || value === undefined || value === "") return null;
  if (field === "date") return parseReportDateForSort(value);
  if (NUMERIC_FIELDS.has(field)) {
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  }
  return String(value).toLowerCase();
};

const compareValues = (left, right) => {
  if (left === null && right === null) return 0;
  if (left === null) return 1;
  if (right === null) return -1;
  if (typeof left === "number" && typeof right === "number") {
    return left - right;
  }
  return String(left).localeCompare(String(right), undefined, {
    sensitivity: "base",
    numeric: true,
  });
};

export const sortQuotationReportRows = (rows, sortConfig) => {
  if (!Array.isArray(rows) || !rows.length) return rows || [];
  if (!sortConfig?.columnIndex || sortConfig.columnIndex === 0) return rows;

  const field = QUOTATION_REPORT_COLUMN_FIELDS[sortConfig.columnIndex];
  if (!field) return rows;

  const direction = sortConfig.direction === "desc" ? -1 : 1;

  return [...rows].sort((rowA, rowB) => {
    const comparison = compareValues(
      getSortValue(rowA, field),
      getSortValue(rowB, field)
    );
    return comparison * direction;
  });
};
